import DeletePredictionsDialog from './DeletePredictionsDialog';

export default DeletePredictionsDialog;
